import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { QuickOrderEntryPageRoutingModule } from './quick-order-entry-routing.module';

import { QuickOrderEntryPage } from './quick-order-entry.page';
import { SharedModule } from '@shared/shared.module';
import { QuickOrderEntryRowDesktopComponent } from '@order/components/quick-order-entry/desktop/quick-order-entry-row-desktop/quick-order-entry-row-desktop.component';
import { QuickOrderEntryRowTabletComponent } from '@order/components/quick-order-entry/tablet/quick-order-entry-row-tablet/quick-order-entry-row-tablet.component';
import { QuickOrderEntryRowMobileComponent } from '@order/components/quick-order-entry/mobile/quick-order-entry-row-mobile/quick-order-entry-row-mobile.component';
import { QuickOrderEntryBaseComponent } from '@order/components/quick-order-entry/quick-order-entry-base.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    QuickOrderEntryPageRoutingModule,
  ],
  declarations: [
    QuickOrderEntryPage,
    QuickOrderEntryBaseComponent,
    QuickOrderEntryRowDesktopComponent,
    QuickOrderEntryRowTabletComponent,
    QuickOrderEntryRowMobileComponent,
  ],
})
export class QuickOrderEntryPageModule {}
